<template>
	<div class="Header">
		<div class="Header-con">
			<div class="Header-con-img" @click="Showpopup">
				<img
					:src="require('@/assets/images/headernav.png')"
					class="img-size"
					alt=""
				/>
			</div>
		</div>
		<div class="Header-code">
			<div class="Header-code-rig" @click="Showercode">
				<div class="code-rig-img">
					<img
						:src="require('@/assets/images/headercode.png')"
						class="img-size"
						alt=""
					/>
				</div>
			</div>
			<transition name="slide-fade">
				<div class="Header-code-mask" v-if="showcode" @click="Hidercode">
					<div class="Header-code-show" @click.stop>
						<div class="code-show-title">
							<div class="show-title-left">
								<div class="title-left-img">
									<img
										:src="require('@/assets/images/headercode.png')"
										class="img-size"
										alt=""
									/>
								</div>
							</div>
							<div class="show-title-rig">{{ $t('微信公众号') }}</div>
						</div>
						<div class="code-show-self">
							<div class="show-self-img">
								<img
									:src="require('@/assets/images/wxqrcode.jpg')"
									class="img-size"
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>
		<van-popup
			v-model="showpopup"
			position="right"
			:overlay-style="overlaystyle"
			width="500"
			:style="{ height: '100%' }"
		>
			<div class="Header-popup">
				<div class="Header-popup-toplogo">
					<div class="Header-popup-title">
						{{ $t('潮州三环（集团）股份有限公司') }}
					</div>
					<div class="Header-popup-logo">
						<img
							:src="
								require(`@/assets/images/${
									lang === 'en' ? 'navlogoEn' : 'navlogo'
								}.png`)
							"
							class="img-size"
							alt=""
						/>
					</div>
				</div>
				<div class="Header-popup-nav">
					<div class="popup-nav-line" @click="Tohome">
						<div class="nav-line-left">
							<div class="line-left-image">
								<img
									:src="require('@/assets/images/navhome.png')"
									class="img-size"
									alt=""
								/>
							</div>
						</div>
						<div class="nav-line-right">{{ $t('首页') }}</div>
					</div>
					<van-collapse
						class="popup-nav-linecol"
						v-model="collapsename"
						:arrow="false"
						:accordion="true"
					>
						<van-collapse-item
							:name="index"
							v-for="(item, index) in itemList"
							:key="index"
							title-class="titleclass"
							:border="false"
						>
							<template #title>
								<div class="linecol-title-circle">
									<div class="title-circle-self"></div>
								</div>
								<div class="linecol-title-text">{{ item.head }}</div>
								<!-- <div class="linecol-title-add">
									<van-icon name="plus" color="#3D3D3D" size="22" />
								</div> -->
							</template>
							<template #right-icon>
								<van-icon name="plus" color="#3D3D3D" size="12" />
							</template>
							<!-- <template #value> -->
							<div class="nav-linecol-con">
								<div
									class="linecol-con-line"
									v-for="(child, idx) in item.indata"
									:key="idx"
									@click="Tojjpath(index, idx, child)"
								>
									<div class="con-line-text">
										{{ getLangText(child, 'name') }}
									</div>
								</div>
							</div>
							<!-- </template> -->
						</van-collapse-item>
					</van-collapse>
					<div class="popup-nav-linecola">
						<div
							class="nav-linecol-title"
							v-for="(item, index) in itembomlist.filter(
								it => !(lang === 'en' && it.head === '投资者关系')
							)"
							:key="index"
							@click="Tonextpath(item)"
						>
							<div class="linecol-title-circle">
								<div class="title-circle-self"></div>
							</div>
							<div class="linecol-title-text">{{ item.head }}</div>
						</div>
					</div>
				</div>
				<van-dropdown-menu active-color="#1989fa">
					<van-dropdown-item
						v-model="local"
						:options="localOption"
						@change="langChange"
					/>
				</van-dropdown-menu>
			</div>
		</van-popup>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showcode: false,
			showpopup: false,
			itemList: [
				{
					head: this.$t('关于三环'),
					indata: [
						{
							name: this.$t('关于我们'),
							url: '/Aboutus'
						},
						{
							name: this.$t('里程碑'),
							url: '/Milestone'
						},
						{
							name: this.$t('企业文化'),
							url: '/Companycultrue'
						},
						{
							name: this.$t('视频宣传'),
							url: '/Videopublicity'
						},
						{
							name: this.$t('集团荣誉'),
							url: '/Grouphonor'
						},
						{
							name: this.$t('领导关怀'),
							url: '/Leadercare'
						}
					]
				},
				{
					head: this.$t('产品信息'),
					indata: []
				}
			],
			itembomlist: [
				{
					head: this.$t('品质服务'),
					url: '/Qualityserve'
				},
				{
					head: this.$t('新闻公告'),
					url: '/Newscenter'
				},
				{
					head: this.$t('人力资源'),
					url: 'https://hr.cctc.cc',
					isLink: true
				},
				{
					head: '投资者关系'
				},
				{
					head: this.$t('联系我们'),
					url: '/Linkus'
				}
			],
			overlaystyle: {
				opacity: 0,
				background: 'none'
			},
			collapsename: '',
			local: localStorage.getItem('lang') || 'zh',
			localOption: [
				{ text: '中文', value: 'zh' },
				{ text: 'English', value: 'en' }
			]
		};
	},
	computed: {
		productList() {
			return this.$store.getters.productList;
		}
	},
	watch: {
		productList(val) {
			this.itemList[1].indata = val;
		}
	},
	methods: {
		//导航跳转
		Tonextpath(item) {
			if (item.isLink) {
				window.location.href = item.url;
				return;
			}
			this.$router.push(item.url + `?lang=${this.lang}`);
		},
		//跳到顶部
		Totop() {
			cancelAnimationFrame(this.timer);
			this.timer = requestAnimationFrame(function fn() {
				const oTop =
					document.body.scrollTop || document.documentElement.scrollTop;
				if (oTop > 0) {
					document.body.scrollTop = document.documentElement.scrollTop =
						oTop - 50;
					this.timer = requestAnimationFrame(fn);
				} else {
					cancelAnimationFrame(this.timer);
				}
			});
		},
		//跳转
		Tojjpath(index, idx, child) {
			this.showpopup = false;
			if (index == 0) {
				this.$router.push(child.url + `?lang=${this.lang}`);
			} else {
				if (this.$route.path === '/Prodoctsec') {
					this.$store.state.Inprosecdata = JSON.stringify(child);
					return;
				}
				localStorage.setItem('productSecItem', JSON.stringify(child));
				this.$router.push({
					name: 'Prodoctsec',
					query: {
						lang: this.lang
					}
				});
			}
		},
		//跳转首页
		Tohome() {
			if (this.$route.path !== '/') {
				this.$router.push({
					name: 'Home',
					query: {
						lang: this.lang
					}
				});
			}
			this.showpopup = false;
		},
		//隐藏公众号二维码
		Hidercode() {
			this.showcode = false;
		},
		//显示公众号二维码
		Showercode() {
			this.showcode = true;
		},
		//打开导航
		Showpopup() {
			this.showpopup = true;
		},
		// 中英文切换
		langChange(command) {
			this.$i18n.locale = command;

			localStorage.setItem('lang', command);
			this.lang = command;
			window.location.href = `/?lang=${command}`;
		}
	}
};
</script>

<style lang="scss">
@use './Header.scss';

.van-dropdown-menu__title,
.van-cell {
	font-size: 24px !important;
}
</style>
